import React from 'react';
import './FooterBanner.css';

const FooterBanner = () => {
    return (
        <section className="footer-banner" id="footer-banner">
            <div className="">
                <div className="footer-banner-content">
                    <div className="banner-text-section">
                        <h2 className="banner-title">Download The App Now!</h2>
                        
                        <div className="app-store-buttons">
                            <a 
                                href="https://play.google.com/store/apps/details?id=com.wmwoan.vrwgli&hl=en_IN&pli=1" 
                                className="app-store-btn"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <img 
                                    src="./assets/GoogleStore.png" 
                                    alt="Get it on Google Play"
                                    className="store-btn-img "
                                />
                            </a>
                            
                            <a 
                                href="https://apps.apple.com/tr/app/harshflixx/id6746354783" 
                                className="app-store-btn"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <img 
                                    src="./assets/AppleStore.png" 
                                    alt="Download on the App Store"
                                    className="store-btn-img"
                                />
                            </a>
                        </div>
                    </div>
                    
                    <div className="banner-phone-section">
                        <div className="phone-mockup">
                            <img 
                                src="./assets/service_image.png" 
                                alt="Mobile App Interface"
                                className="phone-image"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default FooterBanner;